import { IRating } from "../../models/ratings";
import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { UserFigureService } from "../../../../../auth/service/user-figure.service";
import { AuthenticationService } from "../../../../../auth/service";
import { UtilsService } from "../../../../../auth/service/utils.service";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { EducationTitleService } from "../../../../../auth/service/education-title.service";
import { CertificationService } from "../../../../../auth/service/certification.service";
import { SkillsService } from "../../../../../auth/service/skills.service";
import worldLanguages from "../../../../../auth/models/languages";
import languageLevels from "../../../../../auth/models/language-levels";
import { ContractService } from "../../../../../auth/service/contract.service";
import { JobSiteService } from "../../../../../auth/service/job-sites.service";
import { CitiesService } from "../../../../../auth/service/cities.service";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { EducationSubjectService } from "../../../../../auth/service/education-subject.service";
import moment from "moment";
import { RequestService } from "../../../requests/request.service";
import { ManageCandidateContractService } from "../../../../../auth/service/manage-candidate-contract.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CandidateService } from "../../candidate.service";
import { ISkill } from "app/auth/models/skills";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { INoticeTimesObject, INoticeTimesString } from "../../models/candidates";
import { RatingsService } from "../../ratings.service";

@Component({
  selector: "app-candidate-form",
  templateUrl: "./candidate-form.component.html",
  styleUrls: ["./candidate-form.component.scss"],
})
export class CandidateFormComponent implements OnInit {
  public formGroup: FormGroup;
  public contentHeader: IContentHeader;
  public activeTab: string = "masterdata";
  public items_languages: Array<any> = [];
  public items_skills: Array<any> = [];
  public sourcesList: { id: number; name: string }[] = [];
  public fileCurriculum: any;
  public contract_is_changed: boolean = false;
  public indexOfItemSkill: number = 0;
  public language_levels: string[] = languageLevels;
  public languages_list: string[] = worldLanguages;
  public notice_times: INoticeTimesString | INoticeTimesObject[];
  public currentUser: any;
  public candidateRequests: any[] = [];
  public candidateTimeLine: any;
  public openTimeLine: boolean = false;
  public selectedTimeLine: any;
  public isEditCandidate: boolean = false;
  public new_skill: string;
  public fileErrorSize: boolean = false;
  public new_certificate: string = "";
  public items_certifications: any = [];
  public fileName: string = null;
  public currentContractSelected: any = null;
  public skills_list: ISkill[] = [];
  public certifications_list: any = [];
  public requestMatchingLoading: boolean = false;
  private showErrors: any = false;
  public eighteen_years_ago: string = moment().subtract(18, "year").format("YYYY-MM-DD");
  public isSubmitting: boolean = false;
  public candidateFromJobPositions: any = null;
  public candidatureIdFromJobPositions: any = null;
  public selectedEducationName: string = null;
  public isEditingNote: boolean = false;
  public noteToEditSelected: { id: number; note: string; create_date: string; update_date: string; create_by_hash: string; create_by_complete_name: string };
  public userIdentifier: string = null;
  public noteToEditSelectedIndex: number = null;
  public candidateRatingsList: IRating[] = [];
  constructor(
    public _userFigureService: UserFigureService,
    public _authenticationService: AuthenticationService,
    public _utilService: UtilsService,
    private _formBuilder: FormBuilder,
    private _changeDetectorRef: ChangeDetectorRef,
    public _educationTitleService: EducationTitleService,
    public _certificationService: CertificationService,
    public _skillService: SkillsService,
    public _contractService: ContractService,
    public _manageContractService: ManageCandidateContractService,
    public _jobSiteService: JobSiteService,
    public _citiesService: CitiesService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    public _educationSubjectService: EducationSubjectService,
    public _requestService: RequestService,
    public _modalService: NgbModal,
    public _candidateService: CandidateService,
    private _ratingService: RatingsService,
  ) {
    this.contentHeader = {
      headerTitle: "",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.RECRUITMENT",
            isLink: false,
          },
          {
            name: "TITLES.USERS_TYPES.candidate",
            isLink: true,
            link: "/dashboard/candidate/list",
          },
          {
            name: "ADD",
            isLink: false,
          },
        ],
      },
    };

    this.formGroup = this._formBuilder.group({
      firstname: new FormControl("", [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      lastname: new FormControl("", [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      sex: new FormControl("m"),
      birthday: new FormControl(""),
      phone: new FormControl("", [Validators.required, Validators.minLength(9), Validators.maxLength(20)]),
      email: new FormControl("", [Validators.required, Validators.email]),
      figure: new FormControl(null, [Validators.required]),
      source_id: new FormControl(null),
      site: new FormControl(null),
      desired_site: new FormControl(null, [Validators.required]),
      desired_city: new FormControl(null),
      working_city: new FormControl(null, [Validators.required]),
      education_title: new FormControl(null),
      education_subject: new FormControl(null),
      education_vote: new FormControl(null),
      certifications: new FormControl([]),
      notice_resignation: new FormControl(null),
      current_program: new FormControl("full time"),
      current_ccnl: new FormControl("", Validators.maxLength(255)),
      current_contract_type: new FormControl(null),
      current_contract_ral: new FormControl(0),
      current_contract_net_monthly: new FormControl(0),
      current_contract_ticket: new FormControl(0),
      current_contract_bonus: new FormControl(0),
      new_certifications: new FormControl([]),
      note: new FormControl(""),
      judgment: new FormControl(null),
    });

    //Prendiamo i dati nel caso presenti dal queryParam della persona che si è candidata dal sito per poterla inserire come candidato.
    this._activatedRoute.queryParams.subscribe(async (params) => {
      let candidateFromJobPositions: any = params.proposedCandidate;
      if (!!candidateFromJobPositions) {
        this.candidateFromJobPositions = JSON.parse(candidateFromJobPositions);
      }
    });

    this._activatedRoute.paramMap.subscribe(async (params: ParamMap) => {
      this.userIdentifier = params.get("user_identifier");
      if (!this._authenticationService.hasCapability("edit_candidate") && this.userIdentifier) {
        await this._router.navigateByUrl("/dashboard/candidate/list");
        return false;
      }
      if (this.userIdentifier) {
        this._utilService.disableAutoHideLoading();
        this.isEditCandidate = true;
        await this.loadUserData(this.userIdentifier);
      } else {
        this.addSkillItem();
        this.addLanguageItem();
        if (this.candidateFromJobPositions && this.candidateFromJobPositions.cv_url) {
          this.currentUser = { cv_url: this.candidateFromJobPositions.cv_url };
        }
        this._manageContractService.init().then(() => {
          this._manageContractService.resetData();
        });
      }
    });
  }

  async ngOnInit() {
    this.contentHeader.headerTitle = await this._utilService.translate("TITLES.ADD_CANDIDATE");
    await this._educationTitleService.getList();
    await this._certificationService.getList();
    await this._skillService.getList();
    await this._educationSubjectService.getList();
    this.candidateRatingsList = await this._ratingService.getList();
    this.certifications_list = this._certificationService.list;
    this.skills_list = this._skillService.list;
    this.notice_times = await this._utilService.notice_values();

    if (!!this.candidateFromJobPositions) {
      const { firstname, lastname, phone, email, figure_id } = this.candidateFromJobPositions;
      this.formGroup.patchValue({
        firstname,
        lastname,
        phone,
        email,
        figure: figure_id,
        desired_site: this.candidateFromJobPositions.site_id,
        desired_city: this.candidateFromJobPositions.city_id
      });

      this.candidatureIdFromJobPositions = this.candidateFromJobPositions.id;
    }

    this.sourcesList = await this._utilService.basic_get("/candidate-sources")
      .then((res: { id: number; name: string }[]) => {
        if (this.candidateFromJobPositions) {
          const sourceNeptaSite = res.find((source: { name: string }) => source.name === "Sito Nepta");
          if (sourceNeptaSite) {
            this.formGroup.patchValue({
              source_id: sourceNeptaSite.id,
            });
          }
        }
        return res
      })
  }

  async loadUserData(identifier: any) {
    this.currentUser = await this._candidateService
      .getCandidate(identifier)
      .then(async (result: any) => {
        result.certifications
          .filter((c: any) => c.enabled === -1)
          .map((item: any) => {
            this.items_certifications.push({
              id: item.id,
              name: item.name,
            });
          });
        result.certifications = result.certifications.filter((c: any) => c.enabled === 1);
        return result;
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showToastrError("NOT_FOUND_CANDIDATE");
        await this._router.navigateByUrl("/dashboard/candidate/list");
        return false;
      });

    if (!this.currentUser || !this.currentUser.contract) {
      await this._router.navigateByUrl("/dashboard/candidate/list");
    } else {
      const contract: any = {
        level: this.currentUser.contract.desired_level,
        program: this.currentUser.contract.desired_program,
        contract: this.currentUser.contract.desired_contract_type_id,
        contract_name: this.currentUser.contract.desired_contract_type_name,
        net_monthly_12: this.currentUser.contract.desired_net_monthly_12,
        net_monthly_13: this.currentUser.contract.desired_net_monthly_13,
        total_net_monthly_13: this.currentUser.contract.desired_total_net_monthly_13,
        salary_yearly_gross: this.currentUser.contract.desired_salary_gross_yearly,
        total_daily: this.currentUser.contract.desired_total_daily,
        bonus: this.currentUser.contract.desired_bonus,
        ticket_value: this.currentUser.contract.desired_ticket_monthly_value,
        ticket_type: "fisso",
        record_type: "desiderata",
      };
      await this._manageContractService.init(contract);

      this._manageContractService.data.record_type = "desiderata";
      this.formGroup.patchValue({
        firstname: this.currentUser.firstname,
        lastname: this.currentUser.lastname,
        sex: this.currentUser.sex || null,
        phone: this.currentUser.phone,
        email: this.currentUser.email,
        figure: this.currentUser.figure_id || null,
        source_id: this.currentUser.source_id || null,
        site: this.currentUser.contract.current_site_id || null,
        desired_site: this.currentUser.contract.desired_site_id,
        desired_city: this.currentUser.contract.desired_city_id,
        working_city: this.currentUser.working_city_id,
        education_title: this.currentUser.education_title_id,
        education_subject: this.currentUser.education_title_name === "Laurea" ? this.currentUser.education_graduate_id : this.currentUser.education_subject,
        education_vote: this.currentUser.education_vote,
        certifications: this.currentUser.certifications.map((cert: any) => cert.id),
        notice_resignation: this.currentUser.contract.current_notice_resignation,
        current_program: this.currentUser.contract.current_program,
        current_ccnl: this.currentUser.contract.current_ccnl,
        current_contract_type: this.currentUser.contract.current_contract_type || null,
        current_contract_ral: this.currentUser.contract.current_ral ? this._utilService.addDotsToNumber(this.currentUser.contract.current_ral) : 0,
        current_contract_net_monthly: this.currentUser.contract.current_net_monthly ? this._utilService.addDotsToNumber(this.currentUser.contract.current_net_monthly) : 0,
        current_contract_ticket: this._utilService.addDotsToNumber(this.currentUser.contract.current_ticket_monthly_value || 0),
        current_contract_bonus: this._utilService.addDotsToNumber(this.currentUser.contract.current_bonus || 0),
        judgment: this.currentUser.judgment,
      });
      if (!!this.formGroup.value.education_title) {
        const findEducation = this._educationTitleService.list.find((el) => el.id === this.formGroup.value.education_title);
        if (!!findEducation) {
          this.selectedEducationName = findEducation.name;
        }
      }
      if (this.currentUser.contract.current_contract_type_name && this.currentUser.contract.current_contract_type_name.length > 0) {
        this.currentContractSelected = this.currentUser.contract.current_contract_type_name;
      }
      if (this.currentUser.birthday) {
        const date = moment(this.currentUser.birthday);
        this.formGroup.patchValue({ birthday: date.format("YYYY-MM-DD") });
      }

      if (this.currentUser.languages) {
        if (this.currentUser.languages.length < 1) {
          this.addLanguageItem();
        } else {
          this.currentUser.languages.map((lang: any) => {
            this.items_languages.push(lang);
          });
        }
      }
      if (this.currentUser.skills) {
        if (this.currentUser.skills.length < 1) {
          this.addSkillItem();
        } else {
          this.currentUser.skills.map((skill: any) => {
            this.items_skills.push({
              skill: skill.skill_id,
              level: skill.level,
              primary: Boolean(skill.primary),
              enabled: skill.enabled,
            });
          });
        }
      }

      this.contentHeader.headerTitle = this.currentUser.firstname + " " + this.currentUser.lastname;
      this.contentHeader.breadcrumb.links[3].name = "EDIT";

      await this.getCandidateRequests();
      this._utilService.hideLoading();
      this._changeDetectorRef.detectChanges();
    }
  }

  async getCandidateRequests() {
    const colors: string[] = ["secondary", "warning", "info", "info", "danger", "success", "primary"];
    this.candidateRequests = await this._requestService.getSingleCandidateRequests(this.currentUser.hash)
      .then((requests: any) => {
        requests.map((request: any) => {
          request.steps = request.steps
            .map((item: any) => ({ ...item, label_step: `TIMELINE_STEPS_LABELS.STEP_${item.step}_CANDIDATE`, color_step: colors[item.step] }))
            .sort((a: any, b: any) => {
              a = moment(a.insert_date);
              b = moment(b.insert_date);
              return a > b ? -1 : a < b ? 1 : 0;
            });
        });
        return requests;
      });
  }

  async getMatchedRequests() {
    this.requestMatchingLoading = true;
    await this._candidateService.getCandidateMatchRequest(this.currentUser.hash).then((request_match: any) => {
      this.currentUser.request_match = request_match;
      this.requestMatchingLoading = false;
    });
  }

  async changeTimeLineCandidate(id: number) {
    if (this.openTimeLine) {
      this.openTimeLine = false;
      this.selectedTimeLine = null;
      return false;
    }
    if ((this.selectedTimeLine && this.selectedTimeLine !== id) || !this.selectedTimeLine) {
      this.openTimeLine = true;
      if (this.openTimeLine) {
        this.candidateTimeLine = this.candidateRequests.find((request) => request.id === id);
      } else {
        this.candidateTimeLine = null;
      }
    } else {
      this.openTimeLine = !this.openTimeLine;
      this.selectedTimeLine = null;
    }
    this.selectedTimeLine = id;
  }

  changeTab(tab: string) {
    this.activeTab = this.activeTab === tab ? "" : tab;
    this._changeDetectorRef.detectChanges();
  }

  addSkillItem() {
    this.items_skills.push({ skill: 0, level: "", primary: false, enabled: true });
  }

  deleteSkillItem(index: number) {
    delete this.items_skills[index];
    this.items_skills = this.items_skills.filter((i) => i);
  }

  addLanguageItem() {
    this.items_languages.push({
      name: "",
      speak: "",
      write: "",
    });
  }

  deleteLanguageItem(index: number) {
    delete this.items_languages[index];
    this.items_languages = this.items_languages.filter((i) => i);
  }

  handlerChangeFileInput(event: any) {
    if (event.target.files && event.target.files[0].size > 10000000) {
      this._utilService.showToastrError("ERROR_FILE_SIZE");
      this.fileErrorSize = true;
      event.target.result = null;
      event.target.value = null;
      return false;
    }
    this.fileErrorSize = false;
    this.fileName = event.target.files[0].name;
    this._utilService.convertFileToBase64(event, (e: any) => {
      this.fileCurriculum = e.target.result;
    });
  }

  formatCurrentRal() {
    this.formGroup.patchValue({
      current_contract_ral: this._utilService.addDotsToNumber(this.formGroup.value.current_contract_ral),
    });
  }

  formatCurrentTicketTotal() {
    this.formGroup.patchValue({
      current_contract_ticket: this._utilService.addDotsToNumber(this.formGroup.value.current_contract_ticket),
    });
  }

  formatCurrentBonusMonthly() {
    this.formGroup.patchValue({
      current_contract_bonus: this._utilService.addDotsToNumber(this.formGroup.value.current_contract_bonus),
    });
  }

  formatCurrentNetMonthly() {
    this.formGroup.patchValue({
      current_contract_net_monthly: this._utilService.addDotsToNumber(this.formGroup.value.current_contract_net_monthly),
    });
  }

  onSetPrimarySkill(skill: any, i: number) {
    if (skill.primary) {
      this.items_skills.map((value: any, index: number) => {
        if (index !== i) {
          this.items_skills[index].primary = false;
        }
      });
    }
  }

  transformRal(value: any) {
    value = this._utilService.fixRal(value);
    this._manageContractService.changeSalaryGrossYearly(value);
  }

  public modalOpen(modalBasic, index: number) {
    this.new_skill = "";
    this._modalService.open(modalBasic, {
      size: "sm",
      centered: true,
    });
    this.indexOfItemSkill = index;
  }

  async addModalObjectSkill() {
    if (this.new_skill == null) {
      await this._utilService.showToastrError("ERROR_EXPERIENCES_INSERT");
      return false;
    }
    const skillAlreadyExists = this.skills_list.find((skill) => skill.name === this.new_skill.trim());
    if (skillAlreadyExists) {
      await this._utilService.showToastrError("ERROR_SKILL_ALREADY_EXIST_IN_DATABASE");
      return false;
    }
    this.items_skills.push({
      skill: this.new_skill,
      level: "junior",
      enabled: 0,
      primary: 0,
      isNew: true,
    });
    this.new_skill = "";
    this.new_certificate = "";
    this.items_skills = this.items_skills.filter((i) => ((i.skill && i?.skill.length > 0) || i?.skill > 0) && i?.level.length > 0);
  }

  async addModalObjectCertification() {
    if (this.new_certificate == undefined) {
      await this._utilService.showToastrError("ERROR_EXPERIENCES_INSERT");
      return false;
    }
    const certificationAlreadyExists = this.certifications_list.find((item) => item.name === this.new_certificate.trim());
    if (certificationAlreadyExists) {
      await this._utilService.showToastrError("ERROR_SKILL_ALREADY_EXIST_IN_DATABASE");
      return false;
    }

    let alreadyExists: any = this.items_certifications.filter((item) => item.id == this.new_certificate.trim());
    if (alreadyExists && alreadyExists.length > 0) {
      await this._utilService.showToastrError("ERROR_CERTIFICATION_ALREADY_EXIST");
      return false;
    }
    this.items_certifications.push({
      id: this.new_certificate,
      isNew: 1,
      enabled: 0,
    });
    this.new_certificate = "";
  }

  async checkIfAlreadyInsertedSkill(value: any, index: number) {
    if (value === undefined) {
      return false;
    }
    let alreadyExists: any = this.items_skills.filter((item) => item.skill === value.id);
    if (alreadyExists && alreadyExists.length > 1) {
      await this._utilService.showToastrError("ERROR_SKILL_ALREADY_EXIST");
      this.items_skills.splice(index, 1);
    }
  }

  fieldHasErrors(field_name: string): boolean {
    if (this.showErrors) {
      return this.formGroup.controls[field_name].status === "INVALID";
    } else {
      return this.formGroup.controls[field_name].status === "INVALID" && this.formGroup.controls[field_name].touched;
    }
  }

  async setCandidateToSuitable(request_id: number) {
    if (!this._authenticationService.hasCapability("edit_customer_request_step")) {
      window.history.back();
      return false;
    }
    this._utilService.showLoading();
    const data = { step: 0, hash: this.currentUser.hash, request_id: request_id };
    await this._requestService
      .insertStep(data)
      .then(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_INSERT_SUITABLE_CANDIDATE" });
        window.location.reload();
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_INSERT_SUITABLE_CANDIDATE" });
      });
  }

  async save() {
    this.showErrors = true;
    this.isSubmitting = true;
    if (this.formGroup.value.new_certifications && this.formGroup.value.new_certifications.length > 0) {
      //pusho le nuove certificazioni con le certificazioni ufficiali
      this.formGroup.value.new_certifications.map((value) => {
        this.formGroup.value.certifications.push(value);
      });
    }
    delete this.formGroup.value.new_certifications; //Cancellata voce per le nuove certificazioni
    let keyToShowError: any = [];
    Object.keys(this.formGroup.controls).map((key) => {
      if (this.formGroup.controls[key].status === "INVALID") {
        keyToShowError.push(key);
      }
    });
    keyToShowError = await Promise.all(
      keyToShowError.map(async (key) => {
        key = await this._utilService.translate(key.toUpperCase());
        return key.toLowerCase();
      }),
    );

    if (this.formGroup.invalid) {
      let textMessage = await this._utilService.translate("SOME_DATA_ARE_NOT_VALID");
      keyToShowError.map((item, index: number = 0) => {
        index + 1 < keyToShowError.length ? (textMessage += item += ", ") : (textMessage += item += ".");
      });
      this.isSubmitting = false;
      return this._utilService.showSWALEmptyField({ text: textMessage });
    }
    if (this.formGroup.value.current_contract_bonus && this.formGroup.value.current_contract_bonus.length > 0) {
      this.formGroup.value.current_contract_bonus = Number(this._utilService.removeDotsFromNumber(this.formGroup.value.current_contract_bonus));
    }
    if (this.formGroup.value.current_contract_ticket && this.formGroup.value.current_contract_ticket.length > 0) {
      this.formGroup.value.current_contract_ticket = Number(this._utilService.removeDotsFromNumber(this.formGroup.value.current_contract_ticket));
    }
    if (this.formGroup.value.phone) {
      //Togliamo spazi e trattini (-) dal numero di cellulare
      this.formGroup.value.phone = this.formGroup.value.phone.replace(/\s/g, "").trim().replace(/-/g, "");
    }
    this.formGroup.value.firstname = this.formGroup.value.firstname.trim();
    this.formGroup.value.lastname = this.formGroup.value.lastname.trim();
    let data: any = {
      firstname: this.formGroup.value.firstname,
      lastname: this.formGroup.value.lastname,
      sex: this.formGroup.value.sex,
      phone: this.formGroup.value.phone,
      birthday: this.formGroup.value.birthday,
      source_id: this.formGroup.value.source_id,
      email: this.formGroup.value.email,
      figure: this.formGroup.value.figure,
      working_city: this.formGroup.value.working_city,
      education_title: this.formGroup.value.education_title,
      education_subject: this.formGroup.value.education_subject,
      education_vote: this.formGroup.value.education_vote,
      certifications: this.formGroup.value.certifications,
      judgment: this.formGroup.value.judgment,
      note: this.formGroup.value.note ? (this.formGroup.value.note.trim() === "" ? null : this.formGroup.value.note) : null,
      contract: {
        current_contract_type: this.formGroup.value.current_contract_type,
        current_program: this.formGroup.value.current_program,
        current_ccnl: this.formGroup.value.current_ccnl,
        current_bonus: this.formGroup.value.current_contract_bonus,
        current_ral: this.formGroup.value.current_contract_ral,
        current_net_monthly: this.formGroup.value.current_contract_net_monthly,
        current_ticket_monthly_value: this.formGroup.value.current_contract_ticket,
        current_notice_resignation: this.formGroup.value.notice_resignation,
        current_site: this.formGroup.value.site,
        desired_contract_type: this._manageContractService.data.contract,
        desired_city: this.formGroup.value.desired_city,
        desired_site: this.formGroup.value.desired_site,
        desired_salary_gross_yearly: this._manageContractService.data.salary_yearly_gross,
        desired_net_monthly_12: this._manageContractService.data.net_monthly_12,
        desired_net_monthly_13: this._manageContractService.data.net_monthly_13,
        desired_program: this._manageContractService.data.program,
        desired_total_daily: this._manageContractService.data.total_daily,
        desired_total_net_monthly_13: this._manageContractService.data.total_net_monthly_13,
        desired_ticket_monthly_value: this._manageContractService.data.ticket_total,
        desired_bonus: this._manageContractService.data.bonus,
        desired_level: this._manageContractService.data.level,
      },
      skills: !!this.items_skills && this.items_skills.length > 0 ? this.items_skills.filter((i) => (i.skill > 0 || i.skill.length > 0) && i.level.length > 0) : [],
      languages: !!this.items_languages && this.items_languages.length > 0 ? this.items_languages.filter((i) => i?.name?.length > 0 && i?.speak?.length > 0 && i?.write?.length > 0) : [],
      candidature_id: this.candidatureIdFromJobPositions, //Qui se il candidato proviene dalle candidature dalle posizioni lavorative oppure null
    };
    if (data.candidature_id) {
      data.cv_url = this.currentUser.cv_url;
    }
    data.certifications = [...data.certifications, ...this.items_certifications.map((i: any) => i.id)];

    if (this._manageContractService.data.contract_name === "Stage" || this._manageContractService.data.contract_name === "Partita IVA") {
      //Controllo in caso di contratto a stage elimino campi superflui
      data.contract.desired_bonus = 0;
      data.contract.desired_level = null;
      data.contract.desired_net_monthly_13 = 0;
      data.contract.desired_salary_gross_yearly = 0;
      data.contract.desired_ticket_month_number = 0;
      data.contract.desired_ticket_monthly_value = 0;
      data.contract.desired_total_net_monthly_13 = 0;
      if (this._manageContractService.data.contract_name !== "Partita IVA") {
        if (Number(this._utilService.removeDotsFromNumber(data.contract.desired_net_monthly_12)) < 800) {
          this.isSubmitting = false;
          this.activeTab = "contract";
          document.getElementById("contract-section").scrollIntoView({ behavior: "smooth" });
          await this._utilService.showToastrError("ERROR_MIN_NET_MONTHLY_12_STAGE");
          return false;
        }
      } else {
        if (data.contract.desired_total_daily === 0 || Number(this._utilService.removeDotsFromNumber(data.contract.desired_total_daily)) < 5) {
          this.isSubmitting = false;
          this.activeTab = "contract";
          document.getElementById("contract-section").scrollIntoView({ behavior: "smooth" });
          await this._utilService.showToastrError("ERROR_MIN_TOTAL_DAILY_VAT_NUMBER");
          return false;
        }
        data.contract.desired_net_monthly_12 = 0;
      }
    } else {
      if (!data.contract.desired_level || !data.contract.desired_salary_gross_yearly) {
        this.isSubmitting = false;
        this.activeTab = "contract";
        document.getElementById("contract-section").scrollIntoView({ behavior: "smooth" });
        return this._utilService.showToastrError("CONTRACT_DATA_IS_INVALID");
      }

      if (data.contract.desired_ticket_monthly_value !== 0) {
        data.contract.desired_ticket_monthly_value = Number(this._utilService.removeDotsFromNumber(data.contract.desired_ticket_monthly_value)) / 20;
      }
    }

    if (this.items_skills.length < 1) {
      this.activeTab = "skill";
      document.getElementById("skill-section").scrollIntoView({ behavior: "smooth" });
      this.isSubmitting = false;
      return this._utilService.showToastrError("SELECT_LEAST_ONE_SKILL");
    }
    if (data.birthday === "") {
      data.birthday = null;
    }

    if (data.skills.length !== this.items_skills.length) {
      this.activeTab = "skill";
      document.getElementById("skill-section").scrollIntoView({ behavior: "smooth" });
      this.isSubmitting = false;
      return this._utilService.showToastrError("ERROR_SKILLS_FIELDS_EMPTY");
    }

    const checkSkillPrimary = data.skills.filter((skill: any) => skill.primary);
    if (checkSkillPrimary.length < 1) {
      this.activeTab = "skill";
      document.getElementById("skill-section").scrollIntoView({ behavior: "smooth" });
      this.isSubmitting = false;
      return this._utilService.showToastrError("SELECT_PRIMARY_SKILL");
    }
    //check duplicate skills
    const checkedArray = data.skills.reduce((unique: any, o: any) => {
      if (!unique.some((obj: any) => obj.skill === o.skill)) {
        unique.push(o);
      }

      return unique;
    }, []);
    if (data.skills.length !== checkedArray.length) {
      this.isSubmitting = false;
      this.activeTab = "skill";
      document.getElementById("skill-section").scrollIntoView({ behavior: "smooth" });
      await this._utilService.showToastrError("ERROR_DUPLICATE_SKILL");
      return false;
    }

    //END check duplicate skills

    if (!this.contract_is_changed) {
      delete data.contract;
    }

    if (this.currentUser && this.currentUser.hash) {
      if (!this._authenticationService.hasCapability("edit_candidate")) {
        await this._router.navigateByUrl("/dashboard/main");
        return false;
      }
      if (this.fileCurriculum) {
        const uploadCV: any = await this._utilService
          .upload_media("documents", `users/${this.currentUser.hash}/curriculum-personale.pdf`, this.fileCurriculum)
          .then((result: any) => {
            if (result) {
              data.cv_url = result.url.split("documents")[1];
              return true;
            }
            return false;
          })
          .catch((err: any) => {
            console.error(err);
            return false;
          });

        if (!uploadCV) {
          return this._utilService.showToastrError("ERROR_UPLOAD_CURRICULUM");
        }
      }
      return this._candidateService
        .updateCandidate(this.currentUser.hash, data)
        .then(async () => {
          this.isSubmitting = false;
          await this._utilService.showSWALSuccess({ text: "CANDIDATE_UPDATED_SUCCESSFULLY" });
          await this._manageContractService.resetData();
          window.location.reload();
        })
        .catch(() => {
          this.isSubmitting = false;
          this._utilService.showToastrError("CANDIDATE_UPDATED_ERROR");
        });
    } else {
      if (!this._authenticationService.hasCapability("create_candidate")) {
        await this._router.navigateByUrl("/dashboard/main");
        return false;
      }
      return this._candidateService
        .createCandidate(data)
        .then(async (response: any) => {
          if (response.hash) {
            if (this.fileCurriculum) {
              let dataUpdate: any = {};
              const uploadCV: any = await this._utilService
                .upload_media("documents", `users/${response.hash}/curriculum-personale.pdf`, this.fileCurriculum)
                .then((result: any) => {
                  if (result) {
                    dataUpdate.cv_url = result.url.split("documents")[1];
                    return true;
                  }
                  return false;
                })
                .catch((err: any) => {
                  console.error(err);
                  return false;
                });

              if (!uploadCV) {
                return this._utilService.showToastrError("ERROR_UPLOAD_CURRICULUM");
              } else {
                await this._candidateService.updateCandidate(response.hash, dataUpdate);
              }
            }
            this.isSubmitting = false;
            await this._utilService.showToastrSuccess("CANDIDATE_ADDED_SUCCESSFULLY");
            await this._manageContractService.resetData();
            await this._router.navigateByUrl("/dashboard/candidate/list");
          } else {
            this.isSubmitting = false;
            await this._utilService.showToastrError("CANDIDATE_ADDED_ERROR");
          }
        })
        .catch(async () => {
          this.isSubmitting = false;
          await this._utilService.showToastrError("CANDIDATE_ADDED_ERROR");
        });
    }
  }

  resetCurrentContract(value: any) {
    this._utilService.showToastrInfo("INFO_CONTRACT_CURRENT_VALUE_CHANGED");
    this.currentContractSelected = value.name;
    if (this.currentContractSelected === "Partita IVA") {
      this.formGroup.patchValue({ notice_resignation: 0 });
    } else {
      this.formGroup.patchValue({ notice_resignation: null });
    }
    this.formGroup.patchValue({
      current_contract_net_monthly: 0,
      current_contract_ral: 0,
      current_contract_ticket: 0,
      current_contract_bonus: 0,
      current_ccnl: null,
    });
  }

  selectEducation() {
    if (this._educationTitleService.list && this._educationTitleService.list.length > 0) {
      const findEducation = this._educationTitleService.list.find((item) => item.id === this.formGroup.value.education_title);
      if (!!findEducation) {
        this.selectedEducationName = findEducation.name;
      }
    }
  }
  enterEditModeNote(note: { id: number; note: string; create_date: string; update_date: string; create_by_hash: string; create_by_complete_name: string }, index: number) {
    this.isEditingNote = true;
    this.noteToEditSelected = note;
    this.noteToEditSelectedIndex = index;
    this.formGroup.patchValue({
      note: note.note,
    });
  }

  async deleteNote(note_id: number) {
    if (!this._authenticationService.hasCapability("manage_candidate_note")) {
      this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    this._utilService.showLoading();
    await this._candidateService
      .deleteCandidateNote(note_id)
      .then(async () => {
        this._utilService.hideLoading();
        this.currentUser.notes = this.currentUser.notes.filter((note) => note.id !== note_id);
        await this._utilService.showSWALSuccess({ text: "SUCCESS_DELETE_NOTE" });
        this.formGroup.patchValue({ note: null });
        this.isEditingNote = false;
      })
      .catch(async (err: any) => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_DELETE_NOTE" });
        console.error(err);
        return false;
      });
  }

  async saveNote() {
    if (!this._authenticationService.hasCapability("manage_candidate_note")) {
      this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    if (!this.formGroup.value.note || (this.formGroup.value.note && this.formGroup.value.note.trim() === "")) {
      await this._utilService.showSWALError({ text: "INSERT_TEXT" });
      return false;
    }
    this._utilService.showLoading();
    const data: { note: string } = {
      note: this.formGroup.value.note,
    };
    await this._candidateService
      .editCandidateNote(this.noteToEditSelected.id, data)
      .then(async () => {
        this.currentUser.notes[this.noteToEditSelectedIndex].note = this.formGroup.value.note;
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_EDIT_NOTE" });
        this.formGroup.patchValue({ note: null });
        this.isEditingNote = false;
        this.noteToEditSelected = null;
        this.noteToEditSelectedIndex = null;
      })
      .catch(async (err: any) => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_EDIT_NOTE" });
        console.error(err);
        return false;
      });
  }
}
